import plyr from 'plyr';
import { waypointInit } from 'helpers/utils';

const state = {
    player: null,
};

const waypointConfig = {
    selector: '.cta-video',
    funcs: [{ target: 'waypoint--left' }, { target: 'waypoint--right' }],
    offset: '80%',
};

function handlePlayBtn(e) {
    e.preventDefault();

    state.player[e.target.getAttribute('data-index')].play();
}

function setupVideos() {
    state.videos = Array.from(document.getElementsByClassName('js--player'));
    state.videos.forEach((k, i) =>
        k
            .closest('.cta-video')
            .getElementsByClassName('cta-video__link')[0]
            .setAttribute('data-index', i),
    );
    state.player = plyr.setup(state.videos);
}

function init() {
    waypointInit(waypointConfig);
    setupVideos();

    document
        .getElementsByClassName('cta-video__link')[0]
        .addEventListener('click', (e) => handlePlayBtn(e));
}

export default init;
